var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Typography',{staticClass:"my-9 text-grey-400",attrs:{"tag":"div","variant":"body2Light"}},[_c('div',{class:_vm.$style.seo,attrs:{"data-selector":_vm.dataSelectorAttribute},domProps:{"innerHTML":_vm._s(_vm.seoText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }